import { render, staticRenderFns } from "./DominoGameView.vue?vue&type=template&id=57e0eb58&"
import script from "./DominoGameView.vue?vue&type=script&lang=js&"
export * from "./DominoGameView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../.nvm/versions/node/v16.15.0/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports